import React, { useEffect } from "react";
import LandingHeroShowcase from "../components/landing/LandingHeroShowcase";
import PainSection from "../components/landing/PainSection";
import LiveShowcase from "../components/landing/LiveShowcase";

import StatsByNumbers from "../components/landing/StatsByNumbers";
import WhatIsTool from "../components/landing/WhatIsTool";
import FaqSection from "../components/landing/FaqSection";

export default function Landing() {
useEffect(() => {
  document.title = "Link Prospecting Tool | Backlink Banana - Fast & Simple";
  const meta = document.querySelector("meta[name='description']");
  if (meta) {
    meta.setAttribute(
      "content",
      "Backlink Banana helps link builders and SEO professionals find high-quality link prospects fast."
    );
  } else {
    const newMeta = document.createElement("meta");
    newMeta.name = "description";
    newMeta.content =
      "Backlink Banana helps link builders and SEO professionals find high-quality link prospects fast.";
    document.head.appendChild(newMeta);
  }
}, []);

  return (
    <div className="bg-white">
      <main className="pt-24 pb-24 space-y-24 sm:pt-32 sm:pb-32 sm:space-y-32">
  <section id="hero">
    <LandingHeroShowcase />
  </section>

  <section id="pain">
    <PainSection />
  </section>

  <section id="live-showcase">
    <LiveShowcase />
  </section>

  <section id="stats">
    <StatsByNumbers />
  </section>

  <section id="what-is-tool">
    <WhatIsTool />
  </section>

  <section id="faq-section">
    <FaqSection />
  </section>
      </main>

          {/* Footer */}
      <footer className="mt-8 text-gray-500 text-xs text-center px-4">
        <div className="space-x-4 mb-2">
          <a href="/privacy-policy" className="hover:underline">
            Privacy Policy
          </a>
          <span>|</span>
          <a href="/terms-and-conditions" className="hover:underline">
            Terms & Conditions
          </a>
        </div>
        &copy; {new Date().getFullYear()} Backlink Banana
      </footer>
    </div>
  );
}
